export default {
    current_choice: 'Nuvarande val',
    book_now: 'Boka nu',
    minimum_age: 'Endast över {age} år',
    excess_liability: 'Självrisk',
    security_deposit: 'Säkerhetsdeposition',
    fuel_policy: 'Bränslepolicy',
    like_for_like: 'Lika för lika',
    full_to_full: 'Full till full',
    miles_per_rental: '{mileage} fria miles per uthyrning',
    km_per_rental: '{mileage} fria km per uthyrning',
    unlimited_mileage: 'Obegränsad körsträcka',
    unlimited_mileage_km: 'Obegränsad km',
    non_amendable: 'Kan ej ändras',
    non_refundable: 'Ej återbetalningsbar',
    free_cancellation_until: 'Gratis avbokning fram till',
    basic_free_cancellation: 'Gratis avbokning fram till 48 timmar före starttiden',
    cancellation_in_line_with: 'Avbokning enligt',
    tcs: 'Villkor',
    free_extras_on_collection: 'Två gratis tillval vid upphämtning',
    glass_and_tyres_covered: 'Glas och däck täcks',
    number_of_passengers: 'Antal passagerare',
    number_of_bags: 'Antal väskor',
    fuel_type: 'Bränsletyp',
    co2: 'CO2',
    aircon: 'AC',
    transmission: 'Växellåda',
    book_type: 'Boka {type}',
    debit_card_deposit: 'Betalkort accepteras för deposition',
    fast_track_included: 'Snabbspår ingår',
    view_all: 'Visa alla',
};
